import axios from 'axios';

import { notifyOnApiError } from '@/libs/notify';
import router from '@/libs/router';

import { ensureJsonErrors } from '@/../universal/util';


let appVersion;

const CancelToken = axios.CancelToken;
let canceler = CancelToken.source();

axios.defaults.baseURL = appConfig.app.baseApiUrl;
axios.defaults.cancelToken = canceler.token;

axios.getCanceler = () => {
    return CancelToken.source();
};

axios.cancelAll = () => {
    canceler.cancel();
    canceler = CancelToken.source();
    axios.defaults.cancelToken = canceler.token;
};

ensureJsonErrors(axios);

function checkAppVersion(response) {
    if (!response)
        return;

    if (!appVersion) {
        // Store app version on first response
        appVersion = response.headers['x-app-version'];
    } else if (appVersion !== response.headers['x-app-version']) {
        // Reload client on app version mismatch
        window.location.reload();
    }
}

axios.interceptors.response.use(response => {
    checkAppVersion(response);

    return response;
}, err => {
    checkAppVersion(err.response);

    const isAuthError = (err.response && err.response.status === 401);
    const isLoginError = (router.currentRoute.name === 'login');
    const isSilentError = (isAuthError || isLoginError || axios.isCancel(err));

    if (!isSilentError) {
        // Log error data to console
        if (!_.isEmpty(err.response && err.response.data)) {
            debug.error(err.response.data);
        }

        notifyOnApiError(err);
    }

    // Redirect to login on API auth error
    if (isAuthError && router.currentRoute.name !== 'login') {
        delete axios.defaults.headers.common['Authorization'];

        localStorage.removeItem('authToken');
        sessionStorage.setItem('redirectPath', router.currentRoute.fullPath);

        router.push({ name: 'login' });
    }

    return Promise.reject(err);
});
